var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import cx from 'classnames';
import padStart from 'lodash.padstart';
import { observer } from 'mobx-react';
import Pane from '../pane/Pane';
import styles from './console-pane.module.scss';
let ConsolePane = class ConsolePane extends React.Component {
    constructor(props) {
        super(props);
        this._logsBottomEl = null;
        this.onClear = this.onClear.bind(this);
        this.onLogLevel = this.onLogLevel.bind(this);
    }
    onLogLevel() {
        // TODO
    }
    onClear() {
        this.props.store.console.clear();
    }
    componentDidMount() {
        this._scrollToBottom();
    }
    componentDidUpdate() {
        this._scrollToBottom();
    }
    render() {
        const { store } = this.props;
        return (React.createElement(Pane, { className: styles.root, panel: "console", title: "Console", subTitle: store.console.logs.length + '', actions: [
                // { onClick: this.onLogLevel, className: 'fas fa-filter' },
                { onClick: this.onClear, className: 'far fa-trash-alt', title: 'Clear' },
            ], store: store.layout },
            React.createElement("div", { className: styles.logsContainer },
                React.createElement("ul", { className: styles.logsList },
                    store.console.logs.map((l, i) => (React.createElement("li", { className: cx(styles.log, styles[l.level]), key: i },
                        React.createElement("span", { className: styles.time },
                            "[",
                            this._formatTime(l.time),
                            "]"),
                        React.createElement("span", { className: styles.logIcon }),
                        React.createElement("span", { className: styles.message }, l.message)))),
                    React.createElement("div", { className: styles.bottomMarker, ref: (el) => this._logsBottomEl = el })))));
    }
    _scrollToBottom() {
        if (this._logsBottomEl) {
            this._logsBottomEl.scrollIntoView({ behavior: 'smooth' });
        }
    }
    _formatTime(t) {
        const d = new Date(t);
        return (padStart(d.getHours() + '', 2, '0') + ':' +
            padStart(d.getMinutes() + '', 2, '0') + ':' +
            padStart(d.getSeconds() + '', 2, '0') + ':' +
            padStart(d.getMilliseconds() + '', 3, '0'));
    }
};
ConsolePane = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ConsolePane);
export default ConsolePane;
